import '../styles.css';
import PageTitle from '../../../../components/Accessibility/PageTitle';
import VoltarButton from '../../../../components/Accessibility/VoltarButton';
import { useEffect, useState } from 'react';

import Step1EscolherPrestador from './Step1EscolherPrestador';
import { Prestador } from '../../../../interfaces/entities/SaudeBemEstar/Agendamento/Prestador';
import Step2SelecionarData from './Step2SelecionarData';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Horario } from '../../../../interfaces/entities/SaudeBemEstar/Agendamento/Horario';
import Step3ConfirmarDados from './Step3ConfirmarDados';
import { Agendamento } from '../../../../interfaces/entities/Agendamento';
import './styles.css'

const Agendar: React.FC = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const [step, setStep] = useState<number>(1);
  const [prestadorSelected, setPrestadorSelected] = useState<Prestador | undefined>(undefined);
  const [previousAgendamento, setPreviousAgendamento] = useState<Agendamento | null>(null);
  const [horarioSelected, setHorarioSelected] = useState<Horario | undefined>(undefined);

  useEffect(() => {
    const info = location?.state
    if (!info) return

    if (info.prestadorInfo && info.agendamento) {
      setPrestadorSelected(info.prestadorInfo)
      setPreviousAgendamento(info.agendamento)
      setStep(2);
    }
  }, []);

  const onPrestadorSelected = (prestador: Prestador) => {
    setStep(2);
    setPrestadorSelected(prestador);
  }

  const onProsseguirClicked = (datetime: Horario) => {
    setStep(3);
    setHorarioSelected(datetime);
  }

  const renderSwitch = (step: number) => {
    switch(step) {
      case 1: return <Step1EscolherPrestador onAgendarClicked={onPrestadorSelected}/>
      case 2: return <Step2SelecionarData prestador={prestadorSelected} onProsseguirClicked={onProsseguirClicked} onVoltarClicked={() => { setStep(1) }} disallowChange={!!previousAgendamento} />
      case 3: return <Step3ConfirmarDados prestador={prestadorSelected} horario={horarioSelected} prevAgendamento={previousAgendamento} />
    }
  }

  const onVoltarClick = () => {
    if (step === 2 && previousAgendamento) {
      navigate('/saudeBemEstar/unimedAcolhe/agendamentos/lista')
    } else if (step === 1) {
      navigate('/saudeBemEstar/unimedAcolhe/agendamentos')
    } else {
      setStep(step - 1)
    }
  }

  return (
      <div className='page-container-agendar-consulta'>

        <PageTitle text="Agendar consulta" />

        { renderSwitch(step) }
        
        <VoltarButton onClick={onVoltarClick}/>

      </div>
  )
}

export default Agendar;